const images = {
  searchBtn: '/assets/components/CSearch/ic-csearch-btn.png',
  deleteBtn: '/assets/components/CSearch/ic-csearch-delete-btn.png',
};

export default images;
